var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuArrowBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "9px",
    viewBox: "0 0 7 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "@0.5xarrow (black)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Create-Site-Entrance/Exit-Entry",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.87
  }, /*#__PURE__*/React.createElement("g", {
    id: "Walk-in-Express",
    transform: "translate(-288.000000, -134.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "arrow-(black)",
    points: "288 142.148 294.398 138.074 288 134"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuArrowBlack);
export default __webpack_public_path__ + "static/media/menu_arrow_black.3895f975e6dda48d26c7ecf5dcc74e34.svg";
export { ForwardRef as ReactComponent };